module.exports = __webpack_public_path__ + "img/euro.fa54637d.svg";